import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Box, Stack, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";

const TRANSITION = "0.2s ease";

export type RequirementItem = {
  id: string;
  label: string;
  isSatisfied: boolean;
};

type Props = {
  items: ReadonlyArray<RequirementItem>;
};

export const RequirementChecklist = ({ items }: Props) => (
  <Stack gap={0.5} aria-live="polite">
    {items.map(({ id, label, isSatisfied }) => (
      <Stack key={id} direction="row" alignItems="center" gap={1}>
        <Box position="relative" width={18} height={18} flexShrink={0}>
          <RadioButtonUncheckedIcon
            sx={{
              position: "absolute",
              inset: 0,
              fontSize: 18,
              color: "text.disabled",
              opacity: isSatisfied ? 0 : 1,
              transition: `opacity ${TRANSITION}`,
            }}
          />
          <CheckCircleOutlineIcon
            sx={{
              position: "absolute",
              inset: 0,
              fontSize: 18,
              color: Colors.GreenDark,
              opacity: isSatisfied ? 1 : 0,
              transition: `opacity ${TRANSITION}`,
            }}
          />
        </Box>
        <Typography
          variant="body2"
          sx={{
            color: isSatisfied ? Colors.GreenDark : "text.secondary",
            transition: `color ${TRANSITION}`,
          }}
        >
          {label}
        </Typography>
      </Stack>
    ))}
  </Stack>
);
